import React, { useEffect, useState } from 'react';
import { Row, Col, message } from 'antd';
import ListCard from 'Molecules/ListCard';
import HeadingChip from 'Molecules/HeadingChip';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getTerminals } from '../ducks/actions'
import { removeTerminal, bulkRemoveTerminals } from '../ducks/services'
import ActionButton from 'Molecules/ActionButton';
import Search from './components/Search';
import AllRoles from '../../../../routing/config/AllRoles';
import { allowed } from '../../../../routing/config/utils';
import { getListQueryItems } from 'Modules/Application/ducks/actions';
import { useTranslate } from 'Translate';

export default (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const terminals = useSelector((state) => state.pos.terminals);
  const meta = useSelector((state) => state.pos.option);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchVal, setSearchVal] = useState(null);
  const [outlets, setOutlets] = useState([]);
  const allowedEdit = allowed([AllRoles.POS.TERMINAL], 'write');
  const allowedDelete = allowed([AllRoles.POS.TERMINAL], 'delete');
  const globalListQuery = useSelector((state) => state.global.listQueryItems);
  const i18n = useTranslate();
  const { t } = i18n;

  const colName = [
    {
      title: t("Pos.pos_id"),
      dataIndex: 'username',
      key: 'username',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("General.desc"),
      dataIndex: 'alias',
      key: 'alias',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Outlet.outlet_code"),
      dataIndex: 'location_code',
      key: 'location_code',
      className: 'enable-click',
      sorter: true,
      render: (text, record) =>
        <span>{text} {record?.location_desc}</span>
    },
    {
      title: t("Pos.pos_type"),
      dataIndex: 'login_type',
      key: 'login_type',
      className: 'enable-click Sentence',
      sorter: true
    },
    {
      title: t("General.info"),
      dataIndex: 'information',
      key: 'information',
      // className: 'enable-click',
      sorter: false,
      render: (_, record) => 
        <div>
          <div><span className='fw-500'>{t("General.business_date")}:</span> {record?.business_date ?? '-'}</div>
          <div><span className='fw-500'>{t("Pos.current_shift_no")}:</span> {record?.current_shift_no ?? '-'}</div>
          <div><span className='fw-500'>{t("Pos.pos_ver")}:</span> {record?.pos_version ?? '-'}</div>
          <div><span className='fw-500'>{t("Pos.receipt_last_no")}:</span> {record?.receipt_last_no ?? '-'}</div>
          <div><span className='fw-500'>{t("Pos.last_online")}:</span> {record?.last_online_at ?? '-'}</div>
        </div>
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      render: (text, record) =>
        <ActionButton
          title="pos_terminal"
          btnAction1={() => navigate(`/pos/terminal/${record.id}`)}
          recordId={record.id}
          onRemove={allowedDelete && onRemove}
          setLoading={props.setLoading}
          loading={props.loading}
        />
    }
  ];

  const addNew = () => navigate('/pos/terminal/add');

  const btnList = [
    {
      title: t("Confirm.remove_select_terminals"),
      text: t("General.bulk_remove"),
      classes: 'red-btn text-white attendance-success',
      permit: true,
      action: () => onBulkRemove(),
    },
    {
      text: `+ ${t("New.terminal")}`,
      classes: 'attendance-success',
      action: () => addNew(),
    },
  ];

  useEffect(() => {
    if(!globalListQuery.posTerminalListQuery) {
      dispatch(getTerminals(1, limit, '', '', null, props.setLoading));
      dispatch(getListQueryItems('posTerminalListQuery', 1, limit, '', '', null, props.setLoading));
    } else {
      const {page, limit, sortOrder, sortColKey, searchValue} = globalListQuery.posTerminalListQuery
      dispatch(getTerminals(page, limit, sortOrder, sortColKey, searchValue, props.setLoading));
      setPage(page);
      setLimit(limit);
      setSearchVal(searchValue);
    }
  }, []);

  useEffect(() => {
    if(meta) {
      if('locations' in meta) {
        let temp = [];
        meta?.locations?.map((item, index) => {
          if(index === 0) {
            temp.push({
              label: t("General.all_outlets"),
              value: ""
            })
          }
          temp.push({
            label: `${item.code} ${item.desc}`,
            value: item.id
          })
        });
        setOutlets(temp);
      }
    }
  }, [meta])

  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getTerminals(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading));
      dispatch(getListQueryItems('posTerminalListQuery', pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading))
    } else {
      dispatch(getTerminals(pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading));
      dispatch(getListQueryItems('posTerminalListQuery', pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading))
    }
  }

  const onSearch = (search) => {
    setPage(1);
    if (search) {
      let searching = {};
      searching = {
        name: search.name, //username
        code: search.code, //alias
        group: search.group?.value //location_code
      };
      setSearchVal(searching);
      dispatch(getTerminals(1, limit, '', '', searching, props.setLoading));
      dispatch(getListQueryItems('posTerminalListQuery', 1, limit, '', '', searching, props.setLoading))
    } else {
      setSearchVal(null);
      dispatch(getTerminals(1, limit, '', '', null, props.setLoading));
      dispatch(getListQueryItems('posTerminalListQuery', 1, limit, '', '', null, props.setLoading))
    }
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onRemove = async (id) => {
    props.setLoading(true);

    const payload = {
      id: id,
      status_event: 'remove'
    }

    await removeTerminal(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.remove_terminal"));
        setTimeout(() => dispatch(getTerminals(page, limit, '', '', searchVal, props.setLoading)), 500);
        dispatch(getListQueryItems('posTerminalListQuery', page, limit, '', '', searchVal, props.setLoading))
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onBulkRemove = async () => {
    props.setLoading(true);

    const payload = {
      terminals: JSON.stringify(selectedRowKeys)
    }

    await bulkRemoveTerminals(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        rowSelection.onChange([]);
        message.success(t("Success.remove_terminals"));
        setPage(1);
        setSearchVal(null);
        setTimeout(() => dispatch(getTerminals(1, limit, '', '', null, props.setLoading)), 500);
        dispatch(getListQueryItems('posTerminalListQuery', 1, limit, '', '', null, props.setLoading))
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onClickRow = (record) => {
    return {
      onClick: (e) => {
        if (e.target.closest(".enable-click"))
          navigate(`/pos/terminal/${record.id}`)
      },
    };
  };

  return (
    <Row gutter={[10, 10]}>
      <Col span={24}>
        <HeadingChip title={t("General.pos_term")} btnList={allowedEdit ? btnList : null} btnHidden={selectedRowKeys.length <= 0} />
      </Col>
      <Col span={24} className="clickRow">
        <ListCard
          onRow={onClickRow}
          Search={Search}
          onSearch={onSearch}
          searchVal={globalListQuery.posTerminalListQuery?.searchValue}
          ListData={terminals?.list?.map(x => ({ ...x, key: x.id }))}
          onChange={onTableChange}
          ListCol={colName}
          rowSelection={allowedEdit && rowSelection}
          field1={outlets}
          pagination={{
            total: terminals?.total_count,
            current: page,
            pageSize: limit
          }}
        />
      </Col>
    </Row>
  )
}